import thread from "./thread";

export default thread;
